<template>
    <div class="col-lg-8  h-100 eventdetail">
        <Scanner v-if="mode === 'scan'"></Scanner>
        <Event v-else></Event>
    </div>
</template>

<script>
    import Event from './Event.vue';
    import Scanner from './Scanner.vue';

    export default {
        props: [],
        computed: {
            mode() {
                const query = this.$route.query;
                if (query.mode) return query.mode;
                if (query.id) return 'selected';
                return '';
            },
        },
        components: {
            Event,
            Scanner,
        },
    };
</script>